import { useQuery } from "@tanstack/react-query";
import crashBundlesClient from "../../../api/crashBundles";

/** Available analysis models — only providers configured on the API are returned. */
const useAnalysisModelsQuery = (enabled: boolean) =>
  useQuery({
    queryKey: ["crash-analysis-models"],
    queryFn: () => crashBundlesClient.getAnalysisModels(),
    enabled,
  });

export default useAnalysisModelsQuery;
